
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snorapport-recensioner",
      function () {
        return require("private-next-pages/[region]/[resort]/snorapport-recensioner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snorapport-recensioner"])
      });
    }
  